import React, { useState } from 'react';
import {
  Button,
  Card,
  Descriptions,
  Divider,
  Drawer,
  PageHeader,
  Popconfirm,
  Space,
  Tabs,
  Tag,
  Typography,
  notification,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useApproveSellerMutation,
  useBlockSellerMutation,
  useDisableSellerMutation,
  useDeleteSellerMutation,
  useEnableSellerMutation,
  useGetSellerQuery,
} from '../../../app/api/userApiSlice';
import Spinner from '../../../components/common/Spinner';
import BackButton from '../../../components/common/BackButton';
import EditSellerForm from '../containers/EditSellerForm';
import ViewSellerVehicles from '../containers/ViewSellerVehicles';

const ViewSeller: React.FC = () => {
  const navigate = useNavigate();
  const { sellerId } = useParams<{ sellerId: any }>();
  const { data: seller, isLoading } = useGetSellerQuery(sellerId);
  const [approveSeller, { isLoading: loadingApproveSeller }] = useApproveSellerMutation();
  const [blockSeller, { isLoading: loadingBlockSeller }] = useBlockSellerMutation();
  const [enableSeller, { isLoading: loadingEnableSeller }] = useEnableSellerMutation();
  const [disableSeller, { isLoading: loadingDisableSeller }] = useDisableSellerMutation();
  const [deleteSeller, { isLoading: loadingDeleteSeller }] = useDeleteSellerMutation();

  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleApproveSeller = (sellerId: string): void => {
    approveSeller({ id: sellerId })
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Approve Seller Account',
          description: 'Seller account is approved successfully.',
        });

        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRejectSeller = (sellerId: string): void => {
    blockSeller({ id: sellerId })
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Reject Seller Account',
          description: 'Seller account is rejected successfully.',
        });

        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEnableSeller = (): void => {
    if (!seller) return;

    enableSeller(seller.id)
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Enable Seller Account',
          description: 'Seller account enabled successfully.',
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDisableSeller = (): void => {
    if (!seller) return;

    disableSeller(seller.id)
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Disable Seller Account',
          description: 'Seller account disabled successfully.',
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDeleteSeller = (): void => {
    if (!seller) return;

    deleteSeller(seller.id)
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Delete Seller Account',
          description: 'Seller account deleted successfully.',
        });

        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (!seller) {
    return <div>Seller not found!</div>;
  }

  return (
    <>
      <BackButton />
      <PageHeader
        className='site-page-header-responsive'
        title={seller?.personInCharge}
        subTitle={
          <Space>
            <Typography.Text strong>Seller</Typography.Text>

            {seller?.status.id === 1 ? (
              <Tag color='volcano'>Pending</Tag>
            ) : seller?.status.id === 2 ? (
              <>
                <Tag color='green'>Approved</Tag>
                {seller?.isDisable ? (
                  <Tag color='magenta'>Deactivated</Tag>
                ) : (
                  <Tag color='blue'>Active</Tag>
                )}
              </>
            ) : (
              <Tag color='red'>Rejected</Tag>
            )}
          </Space>
        }
        extra={
          seller &&
          seller?.status.id === 1 && [
            <Button
              key='approve'
              type='primary'
              onClick={() => handleApproveSeller(seller.id)}
              loading={loadingApproveSeller}
            >
              Approve
            </Button>,
            <Button
              key='reject'
              type='ghost'
              danger
              onClick={() => handleRejectSeller(seller.id)}
              loading={loadingBlockSeller}
            >
              Reject
            </Button>,
          ]
        }
      >
        <Tabs
          defaultActiveKey='details'
          size='small'
          type='card'
          items={[
            {
              label: 'Details',
              key: 'details',
              children: (
                <Content>
                  <Descriptions
                    layout='horizontal'
                    size='small'
                    column={2}
                    bordered
                    extra={
                      // <Space>
                      //   {seller.isDisable ? (
                      //     <Button
                      //       type='primary'
                      //       ghost
                      //       onClick={() => handleEnableSeller()}
                      //       loading={loadingEnableSeller}
                      //     >
                      //       Activate
                      //     </Button>
                      //   ) : (
                      //     <Button
                      //       type='primary'
                      //       ghost
                      //       onClick={() => handleDisableSeller()}
                      //       loading={loadingDisableSeller}
                      //     >
                      //       Deactivate
                      //     </Button>
                      //   )}
                      //   <Button type='primary' onClick={() => setDrawerVisible(true)}>
                      //     Edit
                      //   </Button>
                      // </Space>
                      <Space>
                        {seller && seller?.status.id === 2 ? (
                          <>
                            {seller.isDisable ? (
                              <Button
                                type='primary'
                                ghost
                                onClick={() => handleEnableSeller()}
                                loading={loadingEnableSeller}
                              >
                                Activate
                              </Button>
                            ) : (
                              <Button
                                type='primary'
                                ghost
                                onClick={() => handleDisableSeller()}
                                loading={loadingDisableSeller}
                              >
                                Deactivate
                              </Button>
                            )}
                          </>
                        ) : (
                          // <>
                          //   {seller && seller?.status.id === 2 && (
                          //     <Button
                          //       type='primary'
                          //       ghost
                          //       danger
                          //       onClick={() => handleDeleteSeller()}
                          //       loading={loadingDeleteSeller}
                          //     >
                          //       Delete
                          //     </Button>
                          //   )}
                          // </>
                          <>
                            {seller && seller?.status.id === 3 && (
                              <Popconfirm
                                title={
                                  <p>
                                    Are you sure you want to delete this seller account?
                                    <br />
                                    This action cannot be undone.
                                  </p>
                                }
                                placement='topLeft'
                                onConfirm={(event) => {
                                  handleDeleteSeller();
                                }}
                                okText='Yes'
                                okButtonProps={{ danger: true }}
                              >
                                <Button type='primary' ghost danger loading={loadingDeleteSeller}>
                                  Delete
                                </Button>
                              </Popconfirm>
                            )}
                          </>
                        )}
                        <Button type='primary' onClick={() => setDrawerVisible(true)}>
                          Edit
                        </Button>
                      </Space>
                    }
                  >
                    <Descriptions.Item
                      label={<Typography.Text strong>Seller Category</Typography.Text>}
                    >
                      {seller?.sellerCategory?.category}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>Name</Typography.Text>}>
                      {seller?.personInCharge}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Company Name</Typography.Text>}
                    >
                      {seller?.companyName}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Representative Person Name</Typography.Text>}
                    >
                      {seller?.representativePersonName}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>Email</Typography.Text>}>
                      {seller?.email}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Phone Number</Typography.Text>}
                    >
                      {seller?.phoneNumber}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>Address 1</Typography.Text>}>
                      {seller?.addressLine1}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>Address 2</Typography.Text>}>
                      {seller?.addressLine2}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>City</Typography.Text>}>
                      {seller?.city}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Postal Code</Typography.Text>}
                    >
                      {seller?.postalCode}
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={<Typography.Text strong>Yard Preference</Typography.Text>}
                    >
                      {seller?.yardType?.type}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Monthly Selling Volume</Typography.Text>}
                    >
                      {seller?.volumeOfPotential?.volume}
                    </Descriptions.Item>
                  </Descriptions>
                  <Divider></Divider>
                  <Typography.Title level={4}>Bank Details</Typography.Title>
                  <Descriptions layout='horizontal' size='small' column={2} bordered>
                    <Descriptions.Item
                      label={<Typography.Text strong>Account Number</Typography.Text>}
                    >
                      {seller?.bankInformation?.accountNumber}
                    </Descriptions.Item>
                    <Descriptions.Item label={<Typography.Text strong>Bank Name</Typography.Text>}>
                      {seller?.bankInformation?.bankName}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={<Typography.Text strong>Bank Branch</Typography.Text>}
                    >
                      {seller?.bankInformation?.bankBranch}
                    </Descriptions.Item>
                  </Descriptions>
                </Content>
              ),
            },
            {
              label: 'Vehicles',
              key: 'vehicles',
              children: (
                <Card>
                  <ViewSellerVehicles sellerId={seller.id} />
                </Card>
              ),
            },
          ]}
        />
        <Drawer
          title='Update Seller Details'
          width={600}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ paddingBottom: 80 }}
          extra={
            <Space>
              <Button onClick={() => setDrawerVisible(false)}>Cancel</Button>
              <Button type='primary' form='updateSellerForm' key='submit' htmlType='submit'>
                Submit
              </Button>
            </Space>
          }
        >
          <EditSellerForm
            seller={seller}
            onSuccessfulSubmit={() => setDrawerVisible(false)}
            drawerVisible={drawerVisible}
          />
        </Drawer>
      </PageHeader>
    </>
  );
};

export default ViewSeller;
